import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import getStatusColor from '../helpers/getStatusColor';
import { LabProcessStatus } from '../hooks/useKits';

interface PillProps {
    status: LabProcessStatus;
    isAdmin: boolean;
    onClick: () => void;
}
const StatusPill = ({ status, isAdmin, onClick }: PillProps) => {
    const classes = useStyles({ status });
    return (
        <div
            className={classes.base}
            style={isAdmin ? { cursor: 'pointer' } : undefined}
            onClick={onClick}
        >
            {status}
        </div>
    );
};

const useStyles = makeStyles<Theme, { status: LabProcessStatus }>((theme) => ({
    base: {
        display: 'flex',
        width: '130px',
        padding: '2px 14px 4px 14px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
        borderRadius: '16px',
        backgroundColor: (props) => getStatusColor(props.status),
        color: theme.palette.primary.main,
        fontFamily: 'Open Sans',
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: '18px', // 150% of 12px
        margin: 'auto',
    },
}));

export default StatusPill;
